<template>
  <div>
    <img :src="imageMap.empty" alt="" class="icon">
    <div class="text">
      {{ text }}
    </div>
    <div class="noticeBoard">
      <div class="notice">
        您只能查询到经由权威媒体发布的新冠肺炎感染者的行程，<!--
        -->如未查询到行程信息并不代表一定没有与新冠肺炎病毒感染者同程，<!--
        -->如出现症状请就近到指定发热门诊救治。
      </div>
      <div class="notice">
        数据错误或问题反馈：zhoumh@133.cn、luxx@133.cn
      </div>
    </div>
    <div class="searchAll" @click="searchAll" v-if="searchType==='user'">
      查询全部行程
    </div>
    <pageFooter>
    </pageFooter>
  </div>
</template>

<script>
  import imageMap   from '../../image-map.js';
  import pageFooter from '../common/page-footer.vue';

  import { mapState, mapMutations } from 'vuex';

  export default {
    components : { pageFooter },

    data() {
      return { imageMap };
    },

    computed : {
      ...mapState( 'virusTrip', [ 'searchType', 'allVirusTrip' ] ),

      text() {
        let result;

        if ( this.allVirusTrip.length === 0 ) {
          result = '服务器繁忙，请稍后重试';
        } else if ( this.searchType === 'train' ) {
          result = '目前尚未发现该火车的同乘旅客中有新冠肺炎确诊患者。';
        } else if ( this.searchType === 'flight' ) {
          result = '目前尚未发现该航班的同乘旅客中有新冠肺炎确诊患者。';
        } else if ( this.searchType === 'user' ) {
          result = '已为您查询自2020年01月01日起的高铁管家订单，您的行程无确诊患者同行';
        } else {
          result = '目前尚未在该城市的市内交通和公共场所发现新冠肺炎确诊患者。';
        }

        return result;
      }
    },

    methods : {
      ...mapMutations( 'virusTrip', [ 'updateSearchType' ] ),

      searchAll() {
        this.updateSearchType( 'all' );
      }
    }
  };
</script>

<style scoped lang="scss">
  @import "./empty.scss";
</style>



// WEBPACK FOOTER //
// src/projects/virusTrip/pages/searchResult/empty.vue